import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Button } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import accounting from 'accounting-js';
import { useGetProductDetailsQuery } from '../slices/productsApiSlice';
import { addToCart, removeFromCart } from '../slices/cartSlice';
import { isCableCategory, getCableMinQty } from '../constants';
import '../assets/styles/ImageWithButton.css';

const Product = ({ product }) => {
    const { userInfo } = useSelector((state) => state.auth);
    const { cartItems } = useSelector((state) => state.cart);
    const { keyword } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Kablo ürünleri metre bazında satılıyor, minimum sipariş 50 metre - kart
    // üzerinden "Sepete Ekle"/"Hemen Satın Al" ile eklenirken otomatik 50'den başlar.
    const [qty, setQty] = useState(product?.category && isCableCategory(product.category) ? getCableMinQty(product.category) : 1);
    
    // Zoom efekti için hover durumunu kontrol eden state
    const [isHovered, setIsHovered] = useState(false);
   
    const { data: productCart } = useGetProductDetailsQuery(product?._id);
    
    const [tempData, setData] = useState({
        ...product,
        finalPrice: product?.price || 0,
        oldPrice: product?.price || 0,
        discountRate: product?.discount || 0,
        isDiscounted: false,
        badgeText: ""
    });

    useEffect(() => {
        if (!product) return;

        let finalPrice = product.price;
        let oldPrice = product.price;
        let discountRate = product.discount || 0;
        let isDiscounted = false;
        let badgeText = "";

        if (userInfo && userInfo.discountItems) {
            const brandDiscount = userInfo.discountItems.find(x => x.brand === product.brand);
            const catDiscount = brandDiscount ? brandDiscount.categories.find(x => x.category === product.category) : null;     
            
            if (brandDiscount && catDiscount && !product.advertisementShow) {
                discountRate = catDiscount.discount;
                finalPrice = product.price - (product.price * discountRate / 100);
                isDiscounted = true;
                
                if (product.extraDiscountShow) {
                    badgeText = `size özel %${accounting.formatMoney(product.extraDiscount, { symbol: "", precision: 2, thousand: ".", decimal: "," })}`;
                }
            } else if (product.advertisementShow) {
                finalPrice = product.price - (product.price * product.discount / 100);
                isDiscounted = true;
                badgeText = "Kampanyalı Fiyat";
            } else if (product.discountShow) {
                finalPrice = product.price - (product.price * product.discount / 100);
                isDiscounted = true;
            }
        }
        else {
            if (product.advertisementShow || product.discountShow) {
                finalPrice = product.price - (product.price * product.discount / 100);
                isDiscounted = true;
                if (product.advertisementShow) badgeText = "Kampanyalı Fiyat";
            }
        }

        setData({
            ...product,
            finalPrice: finalPrice,
            oldPrice: oldPrice,
            discountRate: discountRate,
            isDiscounted: isDiscounted,
            badgeText: badgeText
        });

    }, [product]);

    const createPost = () => {
        if (tempData) dispatch(addToCart({ ...tempData, qty }));
    };

    const removeCart = () => {
        if (product?._id) dispatch(removeFromCart(product._id));
    };

    const handleBuyNow = () => {
        if (tempData) {
            dispatch(addToCart({ ...tempData, qty }));
           // navigate(`/product/${product._id}`);

            navigate('/cart', {
            state: { post_id: keyword, post_id1: keyword }
        });
        }
    };

    const onClick = () => {
        navigate(`/product/${product._id}`, {
            state: { post_id: product._id, post_id1: keyword }
        });
    };
    return (
        <Card 
            className='my-1 p-2 rounded d-flex flex-column' 
            style={{ height: 'fit-content', transition: 'all 0.3s ease' }}
            // Mouse ile giriş ve çıkış olayları hover durumunu günceller
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {product && (
                <>
                    <div 
                        className="image-container" 
                        style={{
                            display: 'flex', justifyContent: 'center', alignItems: 'center',
                            height: '130px', width: '100%', position: 'relative', 
                            overflow: 'hidden', // Büyüyen resmin dışarı taşmasını engeller
                            padding: '5px'
                        }}
                    >
                        <Card.Img 
                            src={product.image} 
                            className="image" 
                            style={{ 
                                maxHeight: '100%', maxWidth: '100%', objectFit: 'contain', width: 'auto', height: 'auto',
                                // Hover durumunda zoom efekti uygular
                                transform: isHovered ? 'scale(1.20)' : 'scale(1)',
                                transition: 'transform 0.2s ease-in-out' // Pürüzsüz geçiş sağlar
                            }}
                        /> 
                        
                        {product.countInStock > 0 && cartItems.find(x => x._id === product._id) && (
                            <Card.Img src="/uploads/Sepette.jpg" style={{ position: 'absolute', bottom: '4px', left: '4px', width: '80px', height: 'auto', zIndex: 5 }} />
                        )}

                        {product.countInStock <= 0 && (
                            <Card.Img src="/uploads/StokYok.jpg" style={{ position: 'absolute', bottom: '4px', left: '4px', width: '80px', height: 'auto', zIndex: 5 }} />
                        )}

                        {product.advertisementShow && (
                            <Card.Img src="/uploads/indirim.jpg" style={{ position: 'absolute', top: '5px', right: '5px', width: '80px', height: 'auto', zIndex: 5 }} /> 
                        )}
                    </div>
                    
                    <Card.Body className="d-flex flex-column px-0 pb-0 flex-grow-1">
                        <Card.Title as='div' className="mb-1">
                            <p 
                                onClick={onClick} title={product.name} 
                                style={{ 
                                    cursor: 'pointer', textDecoration: 'none', fontSize: '0.78rem', lineHeight: '1.1rem', height: '2.2rem', 
                                    display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis', marginBottom: 0
                                }}
                            > 
                                {product.name}
                            </p>
                        </Card.Title>

                         {/* 🌟 GÜNCELLENDİ: Yazı tipi kalınlığı bold (700) yapıldı */}
                         {/* 🌟 GÜNCELLENDİ: text-muted yerine text-dark (koyu siyah) yapıldı ve font kalınlığı artırıldı */}
                        <Card.Text 
                            as='div' 
                            className="text-start ps-1 text-dark mb-2" 
                            style={{ fontSize: '0.72rem', fontWeight: '800', letterSpacing: '0.3px' }}
                        >
                            {product.productCode || product.code || 'KODSUZ ÜRÜN'}
                        </Card.Text>

                        <Row className="align-items-center mt-2 mb-0 g-0 justify-content-center">
                            <Col xs="auto" className="pe-1">
                                {tempData.isDiscounted ? (
                                    <Card.Text style={{ textDecoration: 'line-through', fontSize: '0.75rem', color: '#777', marginBottom: 0 }} as='div'>
                                        {accounting.formatMoney(tempData.oldPrice, { symbol: "", precision: 2, thousand: ".", decimal: "," })}₺
                                    </Card.Text>
                                ) : (
                                    <Card.Text style={{ fontSize: '0.75rem', marginBottom: 0 }} as='div'>&nbsp;</Card.Text>
                                )}
                            </Col>
                      
                            <Col xs="auto" className="ps-1">
                                {tempData.isDiscounted ? (
                                    <div 
                                        style={{ 
                                            backgroundColor: '#111', color: '#fff', borderRadius: '50%', width: '44px', height: '44px',
                                            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', lineHeight: '1.05rem',
                                            textDecoration: (product.extraDiscountShow && !product.advertisementShow) ? 'line-through' : 'none'
                                        }}
                                        title={`%${accounting.formatMoney(tempData.discountRate, { symbol: "", precision: 2, thousand: ".", decimal: "," })} İndirim`}
                                    >
                                        <span style={{ fontSize: '0.85rem', fontWeight: '900' }}>%{parseInt(tempData.discountRate)}</span>
                                        <span style={{ fontSize: '0.45rem', fontWeight: '900', textTransform: 'uppercase', letterSpacing: '0.2px' }}>İndirim</span>
                                    </div>
                                ) : (
                                    <div style={{ width: '42px', height: '42px' }}>&nbsp;</div>
                                )}
                            </Col>
                        </Row>
                        <Row className="mb-0"> 
                            <Col xs={12} className="text-center">
                                {product.priceShow || product.advertisementShow ? (
                                    <Card.Text style={{ fontSize: '1.15rem', fontWeight: 'bold', color: '#333', marginBottom: 0 }} as='div'>
                                        {accounting.formatMoney(tempData.finalPrice, { symbol: "", precision: 2, thousand: ".", decimal: "," })}₺
                                    </Card.Text>
                                ) : (
                                    <Card.Text style={{ fontSize: '1.15rem', marginBottom: 0 }} as='div'>&nbsp;</Card.Text>
                                )}
                            </Col>
                        </Row>

                        <Row className="mb-1"> 
                            <Col xs={12} className="text-center">
                                {tempData.badgeText ? (
                                    <Card.Text 
                                        style={{ 
                                            color: tempData.badgeText.includes("Kampanyalı") ? 'red' : 'green', 
                                            fontSize: '0.7rem', marginBottom: 0, fontWeight: 'bold' 
                                        }} 
                                        as='div'
                                    >
                                        {tempData.badgeText.includes("size özel") ? (
                                            <>size özel <span style={{ fontSize: '11px' }}>%{accounting.formatMoney(product.extraDiscount, { symbol: "", precision: 2, thousand: ".", decimal: "," })}</span></>
                                        ) : (
                                            tempData.badgeText
                                        )}
                                    </Card.Text>
                                ) : (
                                    <Card.Text as='div' style={{ marginBottom: 0 }}>&nbsp;</Card.Text>
                                )}
                            </Col>
                        </Row>

                        <div className="mt-1 mb-0">
                            {product.countInStock > 0 ? (
                                <Row className="g-1 align-items-center">
                                    <Col xs={6}>
                                        {cartItems.find(x => x._id === product._id) ? (
                                            <Button 
                                                size="sm" 
                                                className="w-100 border-0" 
                                                onClick={removeCart}
                                                style={{ fontSize: '0.7rem', fontWeight: 'bold', height: '38px', backgroundColor: '#66CCFF', color: '#ffffff' }}
                                            >
                                                Sepetten Çıkar
                                            </Button>
                                        ) : (
                                            <Button 
                                                size="sm" 
                                                className="w-100 border-0" 
                                                onClick={createPost}
                                                style={{ fontSize: '0.72rem', fontWeight: 'bold', height: '38px', backgroundColor: '#66CCFF', color: '#ffffff' }}
                                            >
                                                Sepete Ekle
                                            </Button>
                                        )}
                                    </Col>

                                    <Col xs={6}>
                                        <Button 
                                            size="sm" 
                                            className="w-100 border-0 d-flex align-items-center justify-content-center" 
                                            onClick={handleBuyNow}
                                            style={{ fontSize: '0.72rem', fontWeight: 'bold', height: '38px', backgroundColor: '#2b2b2b', color: '#ffffff' }}
                                        >
                                            Hemen Satın Al
                                        </Button>
                                    </Col>
                                </Row>
                            ) : (
                                <Button variant="secondary" size="sm" className="w-100" disabled style={{ fontSize: '0.75rem', fontWeight: 'bold', height: '38px' }}>
                                    Stokta Yok
                                </Button>
                            )}
                        </div>
                    </Card.Body>
                </>
            )}
        </Card>
    );
};

export default Product;
